import { create } from 'zustand'

type PromotionSearchInputStore = {
  defaultFilter: string
  actions: {
    setDefaultFilter: (filter: string) => void
  }
}

export const usePromotionSearchInputStore = create<PromotionSearchInputStore>(
  (set) => ({
    defaultFilter: 'p.razao_social_nome',
    actions: {
      setDefaultFilter: (filter) =>
        set(() => ({
          defaultFilter: filter,
        })),
    },
  })
)